import * as Flags from 'country-flag-icons/react/3x2';
import { CountryEnum } from '@/enums';
import { countries } from '@/config';
import { cn } from '@/lib/utils';

type TProps = {
  country?: CountryEnum;
  className?: string;
}

const IconFlag = ({ country, className }: TProps) => {

  if (!country) {
    return <></>;
  }

  const countryCodeIso2 = countries.alpha3ToAlpha2(country)?.toUpperCase();
  const countryName = countries.getName(country, 'fr');
  const Flag = countryCodeIso2 ? Flags[countryCodeIso2 as keyof typeof Flags] : undefined;

  if (!Flag) {
    return <></>;
  }

  return (
    <Flag
      title={countryName}
      className={cn(
        'h-3.5 w-auto rounded-sm',
        className
      )}
    />
  );

};

export default IconFlag;
